<template>
  <div class="base-button-audio" @click="$store.commit('ui/setAudioEnabled', !audioEnabled)">
    <img src="@/assets/img/sound-enabled.svg" v-if="audioEnabled">
    <img src="@/assets/img/sound-disabled.svg" v-else>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: mapState('ui', [
    'audioEnabled'
  ])
}
</script>

<style lang="scss" scoped>
img {
  height: 100%;
  display: block;
}
</style>
